var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.slug},[_c('h5',[_vm._v(_vm._s(category.name))]),_vm._l((category.seasons),function(season){return _c('season-vertical-component',{key:season.slug})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }